// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2fLmn","tab":"ProcedureTabs_tab__B-fof"};